import React, { CSSProperties } from 'react';
import { Classes, Icon } from '../index';
import classNames from 'classnames';
import { mcClear } from '@mc/react-ui-icons';

export type TimeLineProps = {
  steps: Step[];
  vertical?: boolean;
  className?: string;
};

export enum StepStatusEnum {
  COMPLETED = 'completed',
  INCOMPLETED = 'incompleted',
  STORNED = 'storned',
}
export type Step = {
  stepStatus: StepStatusEnum;
  content: React.ReactNode;
};

export const TimeLine: React.FC<TimeLineProps> = ({
  vertical,
  steps,
  className,
}) => {
  const verticalStatusCss: CSSProperties = { width: '10px', height: '10px' };

  return (
    <div
      className={classNames(
        Classes.TIMELINE,
        {
          [Classes.TIMELINE_VERTICAL]: vertical,
        },
        className
      )}
    >
      {steps.map((step, index) => {
        const isFirst = index === 0;
        return (
          <>
            <div className={Classes.TIMELINE_ROW}>
              <div className={Classes.TIMELINE_HEAD}>
                {!isFirst && (
                  <div
                    className={classNames(Classes.TIMELINE_STATUS_SEPARATOR, {
                      [Classes.TIMELINE_STATUS_SEPARATOR_COMPLETED]:
                        step.stepStatus === StepStatusEnum.COMPLETED,
                    })}
                  />
                )}
                {step.stepStatus === StepStatusEnum.STORNED ? (
                  <div style={vertical ? verticalStatusCss : undefined}>
                    <Icon
                      size={'1x'}
                      intent={'inactive'}
                      icon={mcClear}
                      style={vertical ? verticalStatusCss : undefined}
                    />
                  </div>
                ) : (
                  <div
                    className={classNames(Classes.TIMELINE_STATUS, {
                      [Classes.TIMELINE_STATUS_COMPLETED]:
                        step.stepStatus === StepStatusEnum.COMPLETED,
                    })}
                  />
                )}
              </div>
              <div className={Classes.TIMELINE_CONTENT}>{step.content}</div>
            </div>
          </>
        );
      })}
    </div>
  );
};
